import { Action, createReducer, on } from '@ngrx/store';
import * as fromActions from '../actions';

export const updatePaymentRunFeatureKey = 'updatePaymentRun';

export interface UpdatePaymentRunState {
  updatePaymentRunRequest: any;
  updatePaymentRunResponse: any;
  updatePaymentRunFailure: Error | any;
  loaded: boolean;
}

export const initialState: UpdatePaymentRunState = {
  loaded: false,
  updatePaymentRunRequest: undefined,
  updatePaymentRunResponse: undefined,
  updatePaymentRunFailure: undefined
};

export const reducer = createReducer(
  initialState,
  on(fromActions.updatePaymentRun, (state, action) => ({
    ...state,
    updatePaymentRunRequest: action.request
  })),
  on(fromActions.updatePaymentRunSuccess, (state, action) => ({
    ...state,
    updatePaymentRunResponse: action.response,
    loaded: true
  })),
  on(fromActions.updatePaymentRunFailure, (state, action) => ({
    ...state,
    updatePaymentRunFailure: action.error
  }))
);

export const updatePaymentRunResponse = (state: UpdatePaymentRunState) => state.updatePaymentRunResponse;
export const updatePaymentRunFailure = (state: UpdatePaymentRunState) => state.updatePaymentRunFailure;
